/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Isuserallowedtoaccessmicsettings6Inputs */

const en_entity_isuserallowedtoaccessmicsettings6 = /** @type {(inputs: Entity_Isuserallowedtoaccessmicsettings6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is User Allowed To Access Mic Settings`)
};

const de_entity_isuserallowedtoaccessmicsettings6 = /** @type {(inputs: Entity_Isuserallowedtoaccessmicsettings6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer darf Mikrofoneinstellungen öffnen`)
};

/**
* | output |
* | --- |
* | "Is User Allowed To Access Mic Settings" |
*
* @param {Entity_Isuserallowedtoaccessmicsettings6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_isuserallowedtoaccessmicsettings6 = /** @type {((inputs?: Entity_Isuserallowedtoaccessmicsettings6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Isuserallowedtoaccessmicsettings6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_isuserallowedtoaccessmicsettings6(inputs)
	return de_entity_isuserallowedtoaccessmicsettings6(inputs)
});
export { entity_isuserallowedtoaccessmicsettings6 as "entity_isUserAllowedToAccessMicSettings" }